import axios from 'axios';
import { combineReducers } from 'redux';
import { getFormValues, startSubmit, stopSubmit } from 'redux-form';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import { get, sortBy } from 'lodash';

import {
  CLIENT_HEALTH_INSURANCE_FORM,
  CLIENT_PENSION_INSURANCE_FORM,
  CLIENT_EMPLOYMENT_INSURANCE_FORM,
  CLIENT_ACCIDENT_INSURANCE_FORM
} from 'src/constants/FormNames';
import * as Urls from 'src/constants/EndpointUrls';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { itemReducer, listReducer } from 'src/reducers/common';
import { newItem, newItemFailure, setItem } from 'src/reducers/common/itemReducer';
import { setList } from 'src/reducers/common/listReducer';

export const REDUCER_NAME = 'insurance';

export const getHealthInsuranceFormValues = getFormValues(CLIENT_HEALTH_INSURANCE_FORM);
export const getPensionInsuranceFormValues = getFormValues(CLIENT_PENSION_INSURANCE_FORM);
export const getEmploymentInsuranceFormValues = getFormValues(CLIENT_EMPLOYMENT_INSURANCE_FORM);
export const getAccidentInsuranceFormValues = getFormValues(CLIENT_ACCIDENT_INSURANCE_FORM);

export const getDefaultRateForEmployee = (settingStartDate, healthInsuranceSubtype) => {
  const rates = healthInsuranceSubtype.insuranceRate;
  let rate = rates;
  if (isArray(rates) && !isEmpty(rates)) {
    rate = sortBy(rates, r => r.applyStartDate)
      .reverse()
      .find(r => r.applyStartDate <= settingStartDate);
  }

  return get(rate, 'defaultRateForEmployee');
};

export const getDefaultRateForEmployer = (settingStartDate, healthInsuranceSubtype) => {
  const rates = healthInsuranceSubtype.insuranceRate;
  let rate = rates;
  if (isArray(rates) && !isEmpty(rates)) {
    rate = sortBy(rates, r => r.applyStartDate)
      .reverse()
      .find(r => r.applyStartDate <= settingStartDate);
  }

  return get(rate, 'defaultRateForEmployer');
};

export const saveClientHealthInsurance = data => async dispatch => {
  try {
    dispatch(newItem(REDUCER_NAME));
    dispatch(startSubmit(CLIENT_HEALTH_INSURANCE_FORM));
    const httpBody = { clientHealthInsurance: data };
    // const response = await axios.post(Urls.CREATE_CLIENT_HEALTH_INSURANCE, httpBody);
    // if (response.data.errors.length > 0) {
    //   dispatch(newItemFailure(REDUCER_NAME, response.data.errors.messages));
    // } else {
    //   const item = {
    //     ...response.data.payload.clientHealthInsurance,
    //     prefectureId: response.data.payload.prefectureId
    //   };
    //   dispatch(setItem(REDUCER_NAME, item));
    //   dispatch(setList(REDUCER_NAME, { data: response.data.payload.healthInsurances }));
    //   window.location.reload(true);
    // }
  } catch (exception) {
    dispatch(newItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
    dispatch(stopSubmit(CLIENT_HEALTH_INSURANCE_FORM));
  }
};

export const saveClientPensionInsurance = data => async dispatch => {
  try {
    dispatch(newItem(REDUCER_NAME));
    dispatch(startSubmit(CLIENT_PENSION_INSURANCE_FORM));
    const httpBody = { clientPensionInsurance: data };
    const response = await axios.post(Urls.CREATE_CLIENT_PENSION_INSURANCE, httpBody);
    if (response.data.errors.length > 0) {
      dispatch(newItemFailure(REDUCER_NAME, response.data.errors.messages));
    } else {
      dispatch(setItem(REDUCER_NAME, { ...response.data.payload.clientPensionInsurance }));
      dispatch(setList(REDUCER_NAME, { data: response.data.payload.pensionInsurances }));
      window.location.reload(true);
    }
  } catch (exception) {
    dispatch(newItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
    dispatch(stopSubmit(CLIENT_PENSION_INSURANCE_FORM));
  }
};

export const saveClientEmploymentInsurance = data => async dispatch => {
  try {
    dispatch(newItem(REDUCER_NAME));
    dispatch(startSubmit(CLIENT_EMPLOYMENT_INSURANCE_FORM));
    const httpBody = { clientEmploymentInsurance: data };
    const response = await axios.post(Urls.CREATE_CLIENT_EMPLOYMENT_INSURANCE, httpBody);
    if (response.data.errors.length > 0) {
      dispatch(newItemFailure(REDUCER_NAME, response.data.errors.messages));
    } else {
      dispatch(setItem(REDUCER_NAME, { ...response.data.payload.clientEmploymentInsurance }));
      dispatch(setList(REDUCER_NAME, { data: response.data.payload.employmentInsurances }));
      window.location.reload(true);
    }
  } catch (exception) {
    dispatch(newItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
    dispatch(stopSubmit(CLIENT_EMPLOYMENT_INSURANCE_FORM));
  }
};

export const saveClientAccidentInsurance = data => async dispatch => {
  try {
    dispatch(newItem(REDUCER_NAME));
    dispatch(startSubmit(CLIENT_ACCIDENT_INSURANCE_FORM));
    const httpBody = { clientOccupationAccidentInsurance: data };
    const response = await axios.post(Urls.CREATE_CLIENT_ACCIDENT_INSURANCE, httpBody);
    if (response.data.errors.length > 0) {
      dispatch(newItemFailure(REDUCER_NAME, response.data.errors.messages));
    } else {
      dispatch(setItem(REDUCER_NAME, { ...response.data.payload.clientOccupationAccidentInsurance }));
      dispatch(setList(REDUCER_NAME, { data: response.data.payload.accidentInsurances }));
      window.location.reload(true);
    }
  } catch (exception) {
    dispatch(newItemFailure(REDUCER_NAME, exception.response.data.errors.messages));
    dispatch(stopSubmit(CLIENT_ACCIDENT_INSURANCE_FORM));
  }
};

export default combineReducers({
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME),
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME)
});
